/* eslint-disable camelcase */
import React, { useContext, useEffect, useRef, useState } from 'react'
import InputSearch from '../../utils/controls/input-search'
import Buttons from '../../components/buttons/buttons'
import { PageHeader } from '../../layouts/header/page-header'
import PageOverlay from '../../pageoverLay/pageoverLay'
import Noresult from '../noresult/noresult'
import { formatDateandTime, formatTimestamp, getFileNameWithoutExtension, highlightMatchingText, removehtmltags } from '../../Global'
import { decodeHTML } from '../../shared/utility'
import { useInfiniteScroll } from '../../shared/hooks/infiniteScroll'
import { useLocation } from 'react-router-dom'
// import { UserContext } from '../../shared/contexts/role-context'
import { AuthContext } from '../../shared/contexts/AuthContextProvider'
import axios from 'axios'
import { accestoken, BASE_URL } from '../../configuration'

export default function TrendingQuestionsInnerview () {
  const [recentlyQuestions, setRecentlyQuestions] = useState<any>([])
  const [knowlegeGraphItemsActive, setKnowlegeGraphItemsActive] = useState<any>([])
  const [searchQuery, setSearchQuery] = useState<any>()
  const [loading, setLoading] = useState<boolean>(false)
  const [inputValues, setInputValues] = useState<string>()
  const [allData,setallData] = useState<any>([])
  const visibleRows = useInfiniteScroll('wrapper')
  const location:any = useLocation()
  const [showCitationPopup, setShowCitationPopup] = useState<any>(null)
  const citationItemRef = useRef<any>(null)
  const [ popUpTop, setPopUpTop ] = useState<any>()
  const [ popUpRight, setPopUpRight ] = useState<any>()
  const [indexs,setIndex] = useState<any>('')
  const [mainitemindex,setmainindex] = useState<any>('')
      const {loginUserRoles,loadingRoles,accessToken} = useContext(AuthContext)
  useEffect(() => {
    const fetchTopFaqs = async () => {
      const headers = {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': `Bearer ${accessToken}`
    }
        setLoading(true)
        try {
          const faqsResponse = await axios.get(`${BASE_URL}/top_faqs`, { headers })
          const faqsData = faqsResponse.data.top_faqs
            const filteredFaqs = faqsData?.filter((item:any) => item.count >= 2 && item?.email?.toLowerCase() === loginUserRoles?.unique_name?.toLowerCase())
              setRecentlyQuestions(filteredFaqs)
              setallData(filteredFaqs)
            setLoading(false)
        } catch (error:any) {
          console.error(error.message)
          setLoading(false)
        }
      }
      if (!loadingRoles) {
        fetchTopFaqs()
      }
  }, [loadingRoles])
  const redirecttoHome = () => {
    window.location.href = '#'
  }
  const inputValue = (e: any) => {
    if (e?.target?.value) {
      setInputValues(e.target.value)
      setSearchQuery(e.target.value)
     filterItems(e.target.value)
    } else {
      setInputValues('')
      setSearchQuery('')
     filterItems('')
    }
  }
  const changeSearchQuery = (e: any) => {
    setSearchQuery(inputValues)
  }
  const clearAll = (e: any) => {
    setSearchQuery('')
    setInputValues('')
    setRecentlyQuestions(allData)
  }
//   useEffect(() => {
//     filterItems()
//   }, [searchQuery])
  const filterItems = (searchQueryVal : string) => {
    if (searchQueryVal !== '' && searchQueryVal) {
      const filtered = recentlyQuestions.filter((data : any) => {
        const query = data?.query || ''
        const response = removehtmltags(decodeHTML(data?.response)) || ''
        const formattedModified = formatTimestamp(data?.timestamp) || ''
        const queryLowerCase = searchQueryVal.toLowerCase()
 
        return (
          query?.toLowerCase().includes(queryLowerCase) ||
          response?.toLowerCase().includes(queryLowerCase) ||
          formattedModified?.toLowerCase().includes(queryLowerCase)
        )
      })
      setRecentlyQuestions(filtered)
    } else {
        setRecentlyQuestions(allData)
    }
  }

  useEffect(() => {
    if (citationItemRef.current) {
        const mainBtnProps:any = citationItemRef.current.getBoundingClientRect()
        setPopUpTop(mainBtnProps.height + 3)
        setPopUpRight(mainBtnProps.right - mainBtnProps.width)
    }
   
}, [showCitationPopup])

const jsonparser = (data: any, indexss: any) => {
    if (data) {
        const sourcesArray = data?.split('\n') || []
        return (
            <div className="citation-container">
                {sourcesArray.map((source: any, index: any) => {
                    // const cleanedFileName = source?.split('/documents').at(-1)?.split('?')[0]?.replaceAll('%20', ' ')?.replaceAll('.pdf', '')?.replaceAll('/', ' ')?.trim()
                     const cleanedFileName = getFileNameWithoutExtension(source)
                    return (
                        <>
                            <div className="p-relative maxfitcontent">
                                <div key={index} className="citation-item" ref={citationItemRef} onMouseEnter={() => { setShowCitationPopup(true), setIndex(index), setmainindex(indexss) }} onMouseLeave={() => setShowCitationPopup(false)}>
                            <a
                              href={source}
                              onClick={(e) => {
                                e.preventDefault()
                                window.open(source, '_blank', 'noopener,noreferrer')
                              }}
                              title={cleanedFileName}
                            >
                              {cleanedFileName}
                            </a>
                                </div>
                                {/* {showCitationPopup && index === indexs && indexss === mainitemindex &&
                                    <div className='citationPopup' onMouseEnter={() => setShowCitationPopup(true)} onMouseLeave={() => setShowCitationPopup(false)} style={{ position: 'absolute', bottom: `${popUpTop}px`, right: 'auto', left: '0', zIndex: '9999' }}>
                                        <div className='segoeui-semibold font-14 color-primary py-1 lineClamp1'>{cleanedFileName}</div>
                                        <a href={source} target="_blank" rel="noopener noreferrer" className='links1 lineClamp1'>
                                            {source}
                                        </a>
                                    </div>
                                } */}
                            </div>
                        </>
                    )
                })}
            </div>
        )
    } else {
        return null
    }
 }
  return (
    <>
    {loading
      ? <PageOverlay />
      : <>
     <PageHeader name='Trending Questions' badgeClassName={'mt-2 p-1 font-13 px-2'} titleClass='font-24' count={recentlyQuestions?.length?.toString()?.padStart(1, '0')} icon="icon-trendingquestions font-15 me-1 color-primary"
                extras={<>
               <InputSearch
              inputProps={{
                placeholder: 'Search',
                value: searchQuery,
                className:'font-0 d-none'
              }}
              label="Search"
              className='no-border w-100 form-sm title-color51 sourcesanspro font-13'
              searchgroup=' w-100 d-flex align-items-center bordered inputswithicon '
              icon='icon-search pe-2 color-primary'
              onChange={(e: any) => inputValue(e)}
              onClick={(e: any) => changeSearchQuery(e)} />
          <Buttons
            label="Clear All"
            className='ms-auto btn-sm sourcesansprosemibold font-13 d-flex align-items-center links text-decoration-underline'
            type="button"
            onClick={(e: any) => clearAll(e)}
          />
          <Buttons
                label="BACK"
                aria-label="Back"
                icon="icon-rb-arrow-left-thick me-1 font-11"
                className='btn-sm font-14 btn-primary whitetext text-nowrap border-radius'
                onClick={(e: any) => redirecttoHome()}
              />
            </>}
            />
      <div className="container">
        <div className="mt-3">
          <div className="whitebg border-radius p-3 ">
            <div className="font-13  pe-1">
            {recentlyQuestions?.length > 0
              ? recentlyQuestions?.slice(0,visibleRows)?.map((item : any,index:any) =>
                <div key={item?.id}>
                  <div className="mb-3">
                <p className='m-0 color-primary poppins-semibold font13'>
                 <span dangerouslySetInnerHTML={{ __html: highlightMatchingText(item?.query, searchQuery) }}></span></p>
                 {item?.sources &&
                <div className='py-2 d-flex flex-column gap-2'>
                  <span className='segoeui-semibold'>Citations:</span>
                  <span>{jsonparser(item?.sources,index)} </span>
                 </div>}
                  <p tabIndex={0} aria-label={item.response} className="m-0 sourcesanspro subtitle-color9 font-13 px-2 pt-2 chatbot chatbotresponse">
                    <span dangerouslySetInnerHTML={{ __html: highlightMatchingText(item?.response, searchQuery)}}></span>
                  </p>
                  <p tabIndex={0} aria-label={item.Tags} className="m-0 sourcesanspro subtitle-color9 ps-2 font-13">
                      <span
                        className={
                          item?.role === 'public'
                            ? 'border-right2 pe-1 me-1 icon-user-profile title-color9' : 'border-right2 pe-1 me-1 title-color9'
                        }
                      ></span>
                  <span>{loginUserRoles?.name}</span> | <span dangerouslySetInnerHTML={{ __html: highlightMatchingText(
                       formatTimestamp(item.timestamp) || '', searchQuery)}}></span>
                  </p>
                </div><div className='border-bottom29 my-3'></div>
                </div>
                )
              : <div className='min-h-200 d-flex align-items-center justify-content-around'>
            <Noresult />
          </div>}
            </div>
            {/* </InfiniteScroll> */}
          </div>
        </div>
      </div>
    </> }
    </>
  )
}
 
